import { inject, provide, ssrRef, toRef } from '@nuxtjs/composition-api';

export const categoryStoreKey = Symbol('categoryStore');

export function installCategoryContext() {
  /**
   * Category State
   */
  const state = ssrRef(() => ({
    menuSteps: [],
    currentStep: null,
    liveCounts: {},
  }));

  function addMenuStep(menuItem) {
    state.value.menuSteps.push(menuItem);
    state.value.currentStep = menuItem;
  }

  function deleteMenuStep() {
    state.value.menuSteps.splice(-1);
    state.value.currentStep = state.value.menuSteps.slice(-1)[0];
  }

  function clearMenuSteps() {
    state.value.menuSteps = [];
    state.value.currentStep = null;
  }

  function setLiveCounts(data) {
    state.value.liveCounts = {};
    data.map((item) => {
      state.value.liveCounts[item.id] = item.c;
    });
  }

  provide(categoryStoreKey, {
    state,
    menuSteps: toRef(state.value, 'menuSteps'),
    currentStep: toRef(state.value, 'currentStep'),
    addMenuStep,
    deleteMenuStep,
    clearMenuSteps,
    setLiveCounts,
    liveCounts: toRef(state.value, 'liveCounts'),
  });
}

/**
 * @typedef {Object} Category
 * @property {import("@nuxtjs/composition-api").Ref.<array>} menuSteps
 * @property {import("@nuxtjs/composition-api").Ref.<object>} currentStep
 * @property {function} addMenuStep
 * @property {function} deleteMenuStep
 * @property {function} clearMenuSteps
 * @property {function} currentMenuStep
 */

/**
 * @returns {Category} Category State
 */
export function useCategory() {
  return inject(categoryStoreKey);
}
